/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OtherSystemType } from './OtherSystemType';
import {
    OtherSystemTypeFromJSON,
    OtherSystemTypeFromJSONTyped,
    OtherSystemTypeToJSON,
    OtherSystemTypeToJSONTyped,
} from './OtherSystemType';
import type { BaseIntegrationData } from './BaseIntegrationData';
import {
    BaseIntegrationDataFromJSON,
    BaseIntegrationDataFromJSONTyped,
    BaseIntegrationDataToJSON,
    BaseIntegrationDataToJSONTyped,
} from './BaseIntegrationData';
import type { GenericChannelType } from './GenericChannelType';
import {
    GenericChannelTypeFromJSON,
    GenericChannelTypeFromJSONTyped,
    GenericChannelTypeToJSON,
    GenericChannelTypeToJSONTyped,
} from './GenericChannelType';

/**
 * 
 * @export
 * @interface MarketingChannelList
 */
export interface MarketingChannelList {
    /**
     * 
     * @type {Array<BaseIntegrationData>}
     * @memberof MarketingChannelList
     */
    integrationChannels?: Array<BaseIntegrationData>;
    /**
     * 
     * @type {Array<OtherSystemType>}
     * @memberof MarketingChannelList
     */
    otherSystemChannels?: Array<OtherSystemType>;
    /**
     * 
     * @type {Array<GenericChannelType>}
     * @memberof MarketingChannelList
     */
    genericChannels?: Array<GenericChannelType>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarketingChannelList
     */
    unknown?: Array<string>;
}

/**
 * Check if a given object implements the MarketingChannelList interface.
 */
export function instanceOfMarketingChannelList(value: object): value is MarketingChannelList {
    return true;
}

export function MarketingChannelListFromJSON(json: any): MarketingChannelList {
    return MarketingChannelListFromJSONTyped(json, false);
}

export function MarketingChannelListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingChannelList {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationChannels': json['integrationChannels'] == null ? undefined : ((json['integrationChannels'] as Array<any>).map(BaseIntegrationDataFromJSON)),
        'otherSystemChannels': json['otherSystemChannels'] == null ? undefined : ((json['otherSystemChannels'] as Array<any>).map(OtherSystemTypeFromJSON)),
        'genericChannels': json['genericChannels'] == null ? undefined : ((json['genericChannels'] as Array<any>).map(GenericChannelTypeFromJSON)),
        'unknown': json['unknown'] == null ? undefined : json['unknown'],
    };
}

export function MarketingChannelListToJSON(json: any): MarketingChannelList {
    return MarketingChannelListToJSONTyped(json, false);
}

export function MarketingChannelListToJSONTyped(value?: MarketingChannelList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationChannels': value['integrationChannels'] == null ? undefined : ((value['integrationChannels'] as Array<any>).map(BaseIntegrationDataToJSON)),
        'otherSystemChannels': value['otherSystemChannels'] == null ? undefined : ((value['otherSystemChannels'] as Array<any>).map(OtherSystemTypeToJSON)),
        'genericChannels': value['genericChannels'] == null ? undefined : ((value['genericChannels'] as Array<any>).map(GenericChannelTypeToJSON)),
        'unknown': value['unknown'],
    };
}

